/**
 * Makeup Studio Look Prompt Builder (right panel)
 *
 * Mirrors Haircuts Studio pattern:
 * - Takes a selected look preset
 * - Produces a final prompt string (with safety constraints)
 */

export const buildMakeupLookPrompt = ({ look, userCustomPrompt = '' }) => {
  const base = (look?.prompt || '').trim();
  const extra = (userCustomPrompt || '').trim();

  let prompt = base || 'Professional makeup look with natural, photorealistic finish.';

  if (extra) {
    prompt += `\nClient request: ${extra}`;
  }

  // Constraints (keep identity + background untouched)
  prompt += '\nOnly apply makeup. Do not change hair, facial features, face shape, or background.';
  prompt += '\nKeep the same lighting and camera angle.';
  prompt += '\nPhotorealistic texture, no artifacts.';
  prompt += '\nReturn only the final edited image.';

  return prompt;
};

export default buildMakeupLookPrompt;

